<template>
<v-dialog 
v-model="dayPropertiesDialog"
max-width="390"
min-height="100%"
style="overflow-y: auto"
width="100%">
<template 
  v-slot:activator="{ props }">
  <v-btn 
    id="activateInputDayValues"
    v-bind="props"
    icon="mdi-plus" 
    size="large"
    rounded="lg" 
    variant="outlined"
    class="px-0 my-2 mx-4"
    min-width="40"
    height="40"></v-btn>
</template>

<template v-slot:default="{ isActive }">
  <v-card 
          style="overflow-y: auto; max-height: 400vh;"
          rounded="xl"
          color="#E6E6E6">
          <v-btn
              icon="mdi-close"
              elevation="0"
              @click="isActive.value = false; sendCloseEvent()"
              class="bg-grey-lighten-2 align-self-end"
            ></v-btn>
    <Eingabe/>
  </v-card>
</template>
  </v-dialog>
</template>

<script>
import Eingabe from "@/components/Navigation/Eingabe.vue";

export default {
    components:{
      Eingabe
    },
    data() {
      return {
        dayPropertiesDialog: false,
      }
    },
    methods:{
      sendCloseEvent(){
        let myEvent = new Event("dataSyncFinished")
        document.dispatchEvent(myEvent)
      },
    },
}
</script>